<!--屹城采购退货模板-->
<template>
    <div v-loading="loading">
        <div id="printContent" class="print-zone">
            <div v-for="(item, index) in printList" :key="index">
                <div class="print-title">{{ orderData.IsHaveTitleSet ? orderData.OrderTitle : "采购退货单"  }}</div>
                <div class="print-content">
                    <div>退货单号：{{ returnCode }}</div>
                    <div>退货日期：{{ item.ReturnTime }}</div>
                </div>
                <div class="print-table-main">
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 20%;">供应商名称</div>
                        <div class="div-table-cell" style="width: 80%">{{ item.EntpCusName }}</div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell phone-bottom" style="width: 20%">联系电话</div>
                        <div class="div-table-cell phone-bottom" style="width: 80%"></div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 5%">序号</div>
                        <div class="div-table-cell" style="width: 20%;">汽配编码</div>
                        <div class="div-table-cell" style="width: 10%">互换码</div>
                        <div class="div-table-cell" style="width: 11%;">配件名称</div>
                        <div class="div-table-cell" style="width: 19%;">车型</div>
                        <div class="div-table-cell" style="width: 6%">单位</div>
                        <div class="div-table-cell" style="width: 6%">数量</div>
                        <div class="div-table-cell" style="width: 5%">品牌</div>
                        <div class="div-table-cell" style="width: 9%">退单价</div>
                        <div class="div-table-cell" style="width: 9%">退货总额</div>
                    </div>
                    <div class="div-table-row" v-for="(AP, index) in item.DetailList" :key="index">
                        <div class="div-table-cell" style="width: 5%">{{ index + 1 }}</div>
                        <div class="div-table-cell-APcode" style="width: 20%;">{{ AP.APCode }}</div>
                        <div class="div-table-cell-APcode" style="width: 10%">{{ AP.GoodCode }}</div>
                        <div class="div-table-cell textnowrap" style="width: 11%;">{{ AP.GoodName }}</div>
                        <div class="div-table-cell textnowrap" style="width: 19%;">{{ AP.AutoSerise }}</div>
                        <div class="div-table-cell" style="width: 6%">{{ AP.Unit }}</div>
                        <div class="div-table-cell" style="width: 6%">{{ AP.ReturnCount }}</div>
                        <div class="div-table-cell textnowrap" style="width: 5%">{{ AP.Brand }}</div>
                        <div class="div-table-cell" style="width: 9%">{{ AP.PurchasePrice }}</div>
                        <div class="div-table-cell" style="width: 9%">{{  AP.PurchasePrice * AP.ReturnCount ? (AP.PurchasePrice * AP.ReturnCount).toFixed(2) : 0 }}</div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 5%"></div>
                        <div class="div-table-cell" style="width: 20%;"></div>
                        <div class="div-table-cell" style="width: 10%;"></div>
                        <div class="div-table-cell" style="width: 11%;"></div>
                        <div class="div-table-cell" style="width: 19%;">总数量</div>
                        <div class="div-table-cell" style="width: 6%;border-right: none;"></div>
                        <div class="div-table-cell" style="width: 6%">{{ item._count }}</div>
                        <div class="div-table-cell" style="width: 5%"></div>
                        <div class="div-table-cell" style="width: 9%"></div>
                        <div class="div-table-cell" style="width: 9%">{{ item._sumCount.toFixed(2) }}</div>
                    </div>
                </div>
                <div class="row">退款方式：{{ item.PayTypeName }} <span style="margin-left: 240px;">退款金额：{{ item.ReturnMoney }}</span></div>
                <div class="row">退货原因：{{ item.Reasons }}</div>
            </div>
        </div>
        <div class="dialog-footer">
            <el-button class="btn-primary" @click="lodopPrint" v-if="!isDefaultSet">打印</el-button>
            <el-button class="btn-primary" @click="printedRecord" v-print="'#printContent'" v-else>打印</el-button>
            <el-button @click="cancel()">关闭</el-button>
        </div>
    </div>
</template>
<script>
import QRCode from 'qrcode';
export default {
    name: '',
    components: {},
    props: {
        isInit: {
            default: true,
            type: Boolean
        },
        printIds: {
            type: Array
        }
    },
    data() {
        return {
            loading: false,
            printList: [],
            returnCode: '',
            isPrint: false,
            isPreview: false,
            isDefaultSet: false,
            orderData:[],
        };
    },
    created() {},
    mounted() {
        if (this.isInit) {
            this.init();
        } else this.loading = false;
    },
    methods: {
        init() {
            this.printList = [];
            this.getConfigByCodes().then(() => {
                this.getOrder();
            });
        },
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['dyyl', 'syllqdysz'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'dyyl':
                                    this.isPreview = result;
                                    break;
                                case 'syllqdysz':
                                    this.isDefaultSet = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        lodopPrint() {
            let LODOP = this.$lodop.getLodop(); //调用getLodop获取LODOP对象
            if (LODOP) {
                let strBodyStyle = `<style>
                    .order-detail {
                    color: #000;
                    }
                    .order-remark {
                        width: 762px;
                    display: -webkit-flex;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    margin-left: 10px;
                    margin-right: 10px;
                    padding: 0px 0px 15px 0px;
                    color: #000;
                    }
                    .print-title {
                    text-align: center;
                    font-size: 20px;
                    font-weight: bold;
                    color: #000;
                    }
                    .print-content {width: 762px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    color: #000;
                    margin: 12px 0;
                    }
                    .dialog-footer {
                    text-align: right;
                    }
                    .textnowrap{
                        overflow: hidden !important;
                        white-space: nowrap !important;
                        text-overflow:clip !important;
                    }
                    .print-table-main {
                    width: 762px;
                    margin-bottom: 16px;
                    font-size:12px;
                    
                    }
                    .div-table-cell-APcode {
                        overflow:hidden;
                        word-break:break-all;
                        white-space: normal;
                        height: auto;
                        line-height: 30px;
                        padding-left: 10px;
                        border-top: 1px dashed #000;
                        border-right: 1px dashed #000;
                        border-bottom: 1px dashed #000;
                        color: #000;
                    }
                    .div-table-cell {
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        height: auto;
                        line-height: 30px;
                        padding-left: 10px;
                        border-top: 1px dashed #000;
                        border-right: 1px dashed #000;
                        border-bottom: 1px dashed #000;
                        color: #000;
                    }
                    .row {
                    color: #000;
                    margin-bottom: 16px;
                    }
                    .div-table-row {
                        display: flex;
                        border-left: 1px dashed #000;
                        margin: 0;
                        font-size: 14px;
                    }
                    </style>`;

                let strPrintHtml = strBodyStyle + '<body>' + document.getElementById('printContent').innerHTML + '</body>';
                let printHight = document.getElementById('printContent').clientHeight;
                // if (this.printList[0].DetailList.length <= 60) {
                if (this.printList[0].DetailList.length <= 60) {
                    LODOP.SET_PRINT_PAGESIZE(0, '210mm', '93.1mm', '');
                    // top,left,width,height,htmlContent
                    LODOP.ADD_PRINT_HTM(0, 0, '210mm', '100%', strPrintHtml);
                } else {
                    LODOP.SET_PRINT_PAGESIZE(0, '210mm', '93.1mm', '');
                    // top,left,width,height,htmlContent
                    LODOP.ADD_PRINT_HTM('0', '0', '210mm', '100%', strPrintHtml);
                    LODOP.NEWPAGEA();
                }
                //选择操作系统中设为“默认”的打印机，“-1”代表默认打印机
                LODOP.SET_PRINTER_INDEX(-1);
                if (this.isPreview) LODOP.PREVIEW();
                //预览
                else LODOP.PRINT(); // 直接打印

                setTimeout(() => {
                    this.printedRecord();
                }, 1000);
            }
        },
        cancel() {
            this.$emit('closeDialog', this.isPrint);
        },
        printedRecord() {
            this.loading = true;
            this.$util
                .printedRecord({ OrderId: this.printIds[0].PReturnId, Type: 10 }, false)
                .then(() => {
                    this.isPrint = true;
                    this.loading = false;
                    if(!this.isInit)
                        this.$emit('closeDialog', true);
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        getOrder() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpPurReturnOrder/GetYCOrderDetailForPrint',
                    data: {
                        PReturnId: this.printIds[0].PReturnId
                    },
                    hideLoading: this.isInit
                })
                .then(res => {
                    let data = res.data;
                    let detailList = data.DetailList;
                    let values = detailList.reduce(
                        (p, e) => {
                            return {
                                _count: e.ReturnCount * 1 + p._count,
                                _sum: e.PurchasePrice * 1 + p._sum,
                                _sumCount: e.PurchasePrice * e.ReturnCount + p._sumCount

                            };
                        },
                        {
                            _count: 0,
                            _sum: 0,
                            _sumCount: 0

                        }
                    );
                    Object.assign(data, values);
                    this.printList.push(data);
                    this.orderData = res.data;
                    this.returnCode = this.printIds[0].ReturnCode;
                    let that = this;
                    if (that.isInit) that.loading = false;
                    else {
                        this.$nextTick(() => {
                            setTimeout(() => {
                                that.lodopPrint();
                            }, 100);
                        });
                    }                    
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
};
</script>
<style lang="less" scoped>
.order-detail {
    color: #000;
}
.order-remark {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-left: 10px;
    margin-right: 10px;
    padding: 0px 0px 15px 0px;
    color: #000;
}
.print-title {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #000;
}
.print-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #000;
    margin: 12px 0;
}
.dialog-footer {
    text-align: right;
}
.print-table-main {
    margin-bottom: 16px;
    font-size: 12px;
    .div-table-row {
        border-color: black;
        margin-left: 0;
    }
    .div-table-cell-APcode {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: none;
        height: auto;
        line-height: 30px;
        padding-left: 10px;
        border-top: 1px dashed #000;
        border-right: 1px dashed #000;
        border-bottom: 1px dashed #000;
        color: #000;
    }
    .div-table-cell {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: auto;
        line-height: 30px;
        padding-left: 10px;
        border-top: 1px dashed #000;
        border-right: 1px dashed #000;
        border-bottom: 1px dashed #000;
        color: #000;
    }
    .phone-bottom{
        border-bottom :none
    }
}
.row {
    color: #000;
    margin-bottom: 16px;
}
.textnowrap{
    overflow: hidden !important;
  white-space: nowrap !important;
  text-overflow:clip !important;

}
</style>
